<script setup lang="ts">
const { toggle, isOpen } = useNavigation();
const { isExternalUser } = useUser();
</script>

<template>
    <div
        class="flex h-nav-mobile items-center justify-between border-b border-black bg-white pr-4 md:hidden print:hidden"
    >
        <div class="flex items-center">
            <button
                type="button"
                class="z-50 p-4"
                data-base-tour="navBarMobile"
                @click.stop="toggle"
            >
                <BaseIcon
                    :icon-name="isOpen ? 'close' : 'menu'"
                    size="large"
                />
            </button>
            <NuxtLink to="/">
                <BaseLogo title="karriere.at Logo" />
            </NuxtLink>
        </div>
        <NavigationCart v-if="isExternalUser" />
    </div>
</template>
